export function getTranslateString(str, intl) {
  if (typeof str !== 'string' || !intl) {
    return str;
  }

  return str.substring(0, 4) === 'msg_' ? intl.formatMessage({ id: str }) : str;
}
